import { Button } from "components/Button";
import { useOnEscapeKeyPress } from "common/hooks";

export default function AlertModal({ prompt, close }) {
    useOnEscapeKeyPress(close);

    return (
        <div className={`Modal2-wrapper`}>
            <div className="Modal Modal--notification">
                <div className="Modal-body u-pl-lg u-pr-lg">
                    <i className="icon icon-alert icon--lg icon--confirm" />
                    <h2>{prompt}</h2>
                </div>
                <div className="Modal-footer">
                    <Button id="ok-button" secondary onClick={close}>
                        Ok
                    </Button>
                </div>
            </div>
        </div>
    )
}
